/** Presentation only: never replace the technical identity sent to pricing. */
export function shortMeasurementReviewLabel(label: string) {
  const axis = label.match(/\(?\b(footprint area|width|height|length|depth|projection|area|span|perimeter|run|count|number)\)?\s*$/i);
  let base = (axis ? label.slice(0, axis.index) : label)
    .replace(/\s*[—–]\s*|\s+-\s+/g, " ")
    .replace(/\b\d+(?:\.\d+)?\s*[×x]\s*\d+(?:\.\d+)?(?:\s*[×x]\s*\d+(?:\.\d+)?)?\s*(?:UB|UC|RSJ)?\b/gi, "")
    .replace(/\b(?:UB|UC|RSJ)\b/gi, "").trim();
  // Work descriptions do not make useful measurement names. Keep location
  // qualifiers, but don't repeat "room" after an already named room type.
  base = base.replace(/\b(?:renovation|refurbishment|remodelling|remodeling|refit)\b/gi, "");
  if (/\b(?:bathroom|kitchen|bedroom|cloakroom|ensuite|en-suite)\b/i.test(base))
    base = base.replace(/\broom\b/gi, "");
  const words = (text: string) => text.replace(/(?<![\w-])(?:the|a|an|new|existing|proposed|over|below|between|at|on|in|into|to|of|with|for|and|beam|steel|shown|foundation)(?![\w-])/gi, "")
    .replace(/[/,;:()]/g, " ").trim().split(/\s+/).filter(Boolean);
  let name: string[];
  if (/\b(?:windows?|bi[- ]?fold|rooflight|lantern|external door)\b/i.test(base)) {
    // Preserve numbered/location-specific openings rather than giving several
    // distinct windows the same shortened "Kitchen Wall Opening" heading.
    name = words(base).slice(0, 7);
  } else if (/\b(?:opening|doorway)\b/i.test(base)) {
    const location = base.match(/\b(?:opening|doorway)\s+(?:between|at|on|in|to)\s+(?:the\s+)?(.+)/i)?.[1];
    const locationWords = words((location || base)
      .split(/\s+(?:and|into|with|below)\s+|\//i)[0])
      .filter(w => !/^(?:opening|doorway|wall)$/i.test(w));
    name = locationWords.slice(0, 2);
    if (name.length) name.push("Wall");
    name.push("Opening");
  } else if (/\b(?:left|right|rear|front)\s+(?:return|wall)\b/i.test(base)) {
    name = base.match(/\b(?:left|right|rear|front)\s+(?:return|wall)\b/i)![0].split(/\s+/);
  } else {
    name = words(base).slice(0, 4);
  }
  const title = (name.length ? name : ["Measurement"])
    .map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(" ");
  return `${title}${axis ? ` (${axis[1].charAt(0).toUpperCase()}${axis[1].slice(1).toLowerCase()})` : ""}`;
}
